<template>
  <div class="fadeInRight maintenanceOperation">
    <div class="title-box clearfix">
      <span class="m-title">运维操作</span>
    </div>

    <div class="content-box">
      <p>重启应用：</p>

      <el-button
        class="themed-button testReboot"
        type="primary"
        @click="sureRecord"
        >重启monitor</el-button
      >

      <el-button
        class="themed-button testReboot"
        type="success"
        @click="restartWeixinRecord"
        >重启weixin</el-button
      >


      <el-button
        class="themed-button testReboot"
        type="primary"
        @click="restartAPI"
        >重启api</el-button
      >

      <el-button
        class="themed-button testReboot"
        type="success"
        @click="restartWEB"
        >重启web</el-button
      >
    </div>

    <!-- SSL证书管理 -->
    <div class="content-box ssl-cert-section">
      <p>SSL证书管理：</p>
      
      <!-- 当前证书信息 -->
      <div class="cert-info-box" v-if="certInfo">
        <el-card>
          <div slot="header" class="clearfix">
            <span>当前证书信息</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="refreshCertInfo">刷新</el-button>
          </div>
          
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="info-item">
                <label>证书状态：</label>
                <el-tag :type="certInfo.certFileExists && certInfo.keyFileExists ? 'success' : 'danger'">
                  {{ certInfo.certFileExists && certInfo.keyFileExists ? '正常' : '缺失' }}
                </el-tag>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">
                <label>有效期：</label>
                <span>{{ certInfo.expiryDate || '未设置' }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">
                <label>上传时间：</label>
                <span>{{ certInfo.uploadTime || '未知' }}</span>
              </div>
            </el-col>
          </el-row>
          
          <el-row :gutter="20" style="margin-top: 15px;">
            <el-col :span="8">
              <div class="info-item">
                <label>文件名规范：</label>
                <el-tag :type="certInfo.isStandardName ? 'success' : 'warning'">
                  {{ certInfo.isStandardName ? '标准' : '非标准' }}
                </el-tag>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">
                <label>证书大小：</label>
                <span>{{ formatFileSize(certInfo.certFileSize) }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="info-item">
                <label>最后修改：</label>
                <span>{{ certInfo.certFileModified ? formatDate(certInfo.certFileModified) : '未知' }}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>

      <!-- 操作指导 -->
      <div class="cert-guide-box">
        <el-card>
          <div slot="header" class="clearfix">
            <span>📋 SSL证书更新指导</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="toggleGuideExpand">
              {{ guideExpanded ? '收起' : '展开' }}
            </el-button>
          </div>
          
          <el-collapse v-model="activeGuideStep" v-show="guideExpanded">
            <el-collapse-item title="📝 1. 准备工作" name="1">
              <div class="guide-content">
                <h4>获取新的SSL证书</h4>
                <ul>
                  <li>从CA机构（如阿里云、腾讯云、Let's Encrypt等）获取新的SSL证书</li>
                  <li>确保证书包含完整的证书链（.crt/.pem格式证书文件和.key私钥文件）</li>
                  <li>将证书文件和私钥文件打包成zip格式的压缩包</li>
                  <li>记录证书的有效期（到期时间）</li>
                </ul>
                <div class="tip-box">
                  <el-alert title="💡 提示" type="info" :closable="false">
                    <p>• 建议在证书到期前1-2周开始准备新证书</p>
                    <p>• 确保新证书的域名与当前证书一致</p>
                  </el-alert>
                </div>
              </div>
            </el-collapse-item>

            <el-collapse-item title="🔒 2. 备份当前证书" name="2">
              <div class="guide-content">
                <h4>系统自动备份</h4>
                <ul>
                  <li>上传新证书时，系统会自动备份当前证书文件</li>
                  <li>备份文件保存在 <code>/data/ssl_ali/</code> 目录下</li>
                  <li>备份文件名格式：<code>原文件名.bak_时间戳</code></li>
                  <li>如有问题可通过备份文件快速回滚</li>
                </ul>
                <div class="tip-box">
                  <el-alert title="⚠️ 注意" type="warning" :closable="false">
                    <p>系统会自动处理备份，无需手动操作</p>
                  </el-alert>
                </div>
              </div>
            </el-collapse-item>

            <el-collapse-item title="📤 3. 上传新证书" name="3">
              <div class="guide-content">
                <h4>使用下方上传功能</h4>
                <ol>
                  <li><strong>选择证书文件</strong>：点击"选择文件"按钮，选择证书zip压缩包</li>
                  <li><strong>输入有效期</strong>：选择证书的到期日期（格式：yyyy-MM-dd）</li>
                  <li><strong>确认上传</strong>：点击"上传证书"按钮</li>
                  <li><strong>等待完成</strong>：系统会自动解压、备份、替换、重载nginx</li>
                </ol>
                <div class="tip-box">
                  <el-alert title="🎯 重要" type="success" :closable="false">
                    <p>• 支持.crt、.pem格式的证书文件（推荐.pem格式）</p>
                    <p>• 私钥文件必须是.key格式</p>
                    <p>• 系统会自动匹配nginx配置中的文件名</p>
                    <p>• 上传过程中请勿关闭页面</p>
                  </el-alert>
                </div>
              </div>
            </el-collapse-item>

            <el-collapse-item title="🔍 4. 验证新证书" name="4">
              <div class="guide-content">
                <h4>确认证书生效</h4>
                <ul>
                  <li><strong>检查网站访问</strong>：确保网站可以正常通过HTTPS访问</li>
                  <li><strong>验证证书信息</strong>：浏览器地址栏点击锁图标，查看证书详情</li>
                  <li><strong>检查有效期</strong>：确认证书有效期与上传时设置的一致</li>
                  <li><strong>测试各功能</strong>：确保网站各功能模块正常工作</li>
                </ul>
                <div class="tip-box">
                  <el-alert title="🔧 验证工具" type="info" :closable="false">
                    <p>• 可使用SSL Labs等在线工具检测证书配置</p>
                    <p>• 建议在不同浏览器中测试访问</p>
                  </el-alert>
                </div>
              </div>
            </el-collapse-item>

            <el-collapse-item title="🚨 5. 问题处理" name="5">
              <div class="guide-content">
                <h4>常见问题及解决方案</h4>
                <div class="problem-section">
                  <h5>🔴 上传失败</h5>
                  <ul>
                    <li>检查压缩包是否包含证书文件(.crt/.pem)和私钥文件(.key)</li>
                    <li>确认文件格式正确（不是.txt或其他格式）</li>
                    <li>检查文件大小是否超过50MB限制</li>
                  </ul>
                </div>
                <div class="problem-section">
                  <h5>🔴 nginx重载失败</h5>
                  <ul>
                    <li>检查证书文件格式是否正确</li>
                    <li>确认私钥与证书匹配</li>
                    <li>联系系统管理员检查nginx配置</li>
                  </ul>
                </div>
                <div class="problem-section">
                  <h5>🔴 网站无法访问</h5>
                  <ul>
                    <li>等待3-5分钟，DNS可能需要时间更新</li>
                    <li>清除浏览器缓存后重试</li>
                    <li>如问题持续，联系技术支持进行回滚</li>
                  </ul>
                </div>
                <div class="tip-box">
                  <el-alert title="🆘 紧急情况" type="error" :closable="false">
                    <p>如遇到严重问题导致网站无法访问，请立即联系技术支持进行紧急处理</p>
                  </el-alert>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-card>
      </div>

      <!-- 证书上传 -->
      <div class="cert-upload-box">
        <el-card>
          <div slot="header" class="clearfix">
            <span>上传新证书</span>
          </div>
          
          <el-form ref="uploadForm" :model="uploadForm" :rules="uploadRules" label-width="100px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="证书文件" prop="certFile">
                  <el-upload
                    ref="upload"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                    :auto-upload="false"
                    :on-change="handleFileChange"
                    :before-remove="beforeRemove"
                    accept=".zip"
                    action="#">
                    <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传zip格式的证书压缩包</div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书有效期" prop="expiryDate">
                  <el-date-picker
                    v-model="uploadForm.expiryDate"
                    type="date"
                    placeholder="选择证书有效期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    style="width: 100%;">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            
            <el-form-item>
              <el-button type="success" @click="submitUpload" :loading="uploading">
                {{ uploading ? '上传中...' : '上传证书' }}
              </el-button>
              <el-button @click="resetForm">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      
      <!-- 提示信息 -->
      <div class="ssl-notice-box">
        <el-card>
          <div slot="header">
            <span>📧 邮件提醒说明</span>
          </div>
          <el-alert
            title="SSL证书到期邮件提醒已启用"
            type="success"
            show-icon
            :closable="false">
            <div slot="description">
              <p>• <strong>提醒时机</strong>：证书到期前3天开始，每天发送提醒邮件</p>
              <p>• <strong>过期通知</strong>：证书过期后每天发送紧急通知邮件</p>
              <p>• <strong>更新通知</strong>：证书更新成功/失败时自动发送通知邮件</p>
              <p>• <strong>服务器标识</strong>：邮件标题会包含服务器标识，便于区分不同服务器</p>
              <p>• <strong>配置说明</strong>：请在"系统管理 → 字典管理"中配置相关参数</p>
              <div style="background: #f5f5f5; padding: 10px; border-radius: 4px; margin-top: 10px;">
                <p style="margin: 5px 0;"><strong>📧 邮件配置：</strong></p>
                <p style="margin: 2px 0;">字典组: <code>SSL_CERT_CONFIG</code></p>
                <p style="margin: 2px 0;">字典键: <code>SSL_EXPIRY_EMAIL</code></p>
                <p style="margin: 2px 0;">字典值: <code>admin@example.com,ops@example.com</code></p>
                <p style="margin: 2px 0; color: #909399; font-size: 12px;">提示：多个邮箱可用逗号或分号分隔，系统会自动格式化</p>
                
                <p style="margin: 10px 0 5px 0;"><strong>🖥️ 服务器标识：</strong></p>
                <p style="margin: 2px 0;">字典组: <code>SSL_CERT_CONFIG</code></p>
                <p style="margin: 2px 0;">字典键: <code>SSL_SERVER_IDENTIFIER</code></p>
                <p style="margin: 2px 0;">字典值: <code>生产服务器 (192.168.1.100 主机名)</code></p>
              </div>
            </div>
          </el-alert>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import onresize from "@/mixins/resize.js";
import { restartMonitor, restartWeixin, restartWeb, restartApi, getSslCertInfo, uploadSslCert } from "@/api/systemManagement.js";
export default {
  name: "maintenanceOperation",
  mixins: [onresize],
  data() {
    return {
      // SSL证书相关数据
      certInfo: null,
      uploading: false,
      fileList: [],
      uploadForm: {
        certFile: null,
        expiryDate: ''
      },
      uploadRules: {
        certFile: [
          { required: true, message: '请选择证书文件', trigger: 'change' }
        ],
        expiryDate: [
          { required: true, message: '请选择证书有效期', trigger: 'change' }
        ]
      },
      // 指导步骤相关数据
      guideExpanded: false,
      activeGuideStep: ['1']
    };
  },
  created() {
    this.loadCertInfo();
  },
  methods: {
    sureRecord() {
      restartMonitor({}).then((res) => {
        console.log(res);
        if (res.system_result_key == "0") {
          this.$alert("请求执行成功，会自动完成重启，请稍后。", "标题", {
            confirmButtonText: "确定",
          });
        } else {
          this.$message({
            showClose: true,
            message: res.system_result_message_key,
            type: "error",
          });
        }
      });
    },
    restartWeixinRecord() {
      restartWeixin({}).then((res) => {
        console.log(res);
        if (res.system_result_key == "0") {
          this.$alert("请求执行成功，会自动完成重启，请稍后。", "标题", {
            confirmButtonText: "确定",
          });
        } else {
          this.$message({
            showClose: true,
            message: res.system_result_message_key,
            type: "error",
          });
        }
      });
    },


    restartWEB() {
      restartWeb({}).then((res) => {

           this.$alert(res, "标题", {
            confirmButtonText: "确定",
          });
        // console.log(res);
        // if (res.system_result_key == "0") {
        //   this.$alert("请求执行成功，会自动完成重启，请稍后。", "标题", {
        //     confirmButtonText: "确定",
        //   });
        // } else {
        //   this.$message({
        //     showClose: true,
        //     message: res.system_result_message_key,
        //     type: "error",
        //   });
        // }
      });
    },

    restartAPI() {
      restartApi({}).then((res) => {
        console.log(res);
        if (res.system_result_key == "0") {
          this.$alert("请求执行成功，会自动完成重启，请稍后。", "标题", {
            confirmButtonText: "确定",
          });
        } else {
          this.$message({
            showClose: true,
            message: res.system_result_message_key,
            type: "error",
          });
        }
      });
    },

    // SSL证书管理相关方法
    loadCertInfo() {
      getSslCertInfo({}).then((res) => {
        if (res.system_result_key == "0") {
          this.certInfo = res.system_result_data_key;
        } else {
          this.$message({
            showClose: true,
            message: res.system_result_message_key || '获取证书信息失败',
            type: "error",
          });
        }
      }).catch((error) => {
        console.error('获取证书信息失败:', error);
        this.$message({
          showClose: true,
          message: '获取证书信息失败',
          type: "error",
        });
      });
    },

    refreshCertInfo() {
      this.loadCertInfo();
      this.$message({
        message: '证书信息已刷新',
        type: 'success'
      });
    },

    handleExceed() {
      this.$message({
        message: '只能选择一个文件！',
        type: 'warning'
      });
    },

    handleFileChange(file, fileList) {
      this.fileList = fileList;
      this.uploadForm.certFile = file.raw;
      
      // 验证文件格式
      if (!file.name.toLowerCase().endsWith('.zip')) {
        this.$message({
          message: '只能上传zip格式的文件！',
          type: 'error'
        });
        this.fileList = [];
        this.uploadForm.certFile = null;
        return false;
      }

      // 验证文件大小 (50MB)
      if (file.size > 50 * 1024 * 1024) {
        this.$message({
          message: '文件大小不能超过50MB！',
          type: 'error'
        });
        this.fileList = [];
        this.uploadForm.certFile = null;
        return false;
      }
    },

    beforeRemove(file, fileList) {
      this.uploadForm.certFile = null;
      return true;
    },

    submitUpload() {
      this.$refs.uploadForm.validate((valid) => {
        if (valid) {
          this.confirmUpload();
        } else {
          this.$message({
            message: '请完成表单填写',
            type: 'error'
          });
          return false;
        }
      });
    },

    confirmUpload() {
      this.$confirm('上传新证书将替换当前证书，确定要继续吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doUpload();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消上传'
        });
      });
    },

    doUpload() {
      this.uploading = true;
      
      const formData = new FormData();
      formData.append('certFile', this.uploadForm.certFile);
      formData.append('expiryDate', this.uploadForm.expiryDate);

      uploadSslCert(formData).then((res) => {
        this.uploading = false;
        
        if (res.system_result_key == "0") {
          // 显示后端返回的详细消息（包含邮件发送状态）
          const message = res.system_result_message_key || 'SSL证书上传成功，nginx已重载！';
          this.$alert(message, '成功', {
            confirmButtonText: '确定',
            type: 'success'
          });
          
          // 重置表单
          this.resetForm();
          
          // 刷新证书信息
          setTimeout(() => {
            this.loadCertInfo();
          }, 1000);
        } else {
          this.$message({
            showClose: true,
            message: res.system_result_message_key || '上传失败',
            type: 'error',
            duration: 5000  // 错误消息显示更长时间
          });
        }
      }).catch((error) => {
        this.uploading = false;
        console.error('上传失败:', error);
        this.$message({
          showClose: true,
          message: '网络错误，上传失败',
          type: 'error'
        });
      });
    },

    resetForm() {
      this.$refs.uploadForm.resetFields();
      this.fileList = [];
      this.uploadForm.certFile = null;
      this.$refs.upload.clearFiles();
    },

    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    formatDate(dateStr) {
      if (!dateStr) return '未知';
      const date = new Date(dateStr);
      return date.toLocaleString('zh-CN', { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit',
        hour: '2-digit', 
        minute: '2-digit',
        second: '2-digit'
      });
    },

    // 指导步骤相关方法
    toggleGuideExpand() {
      this.guideExpanded = !this.guideExpanded;
      if (this.guideExpanded && this.activeGuideStep.length === 0) {
        this.activeGuideStep = ['1'];
      }
    }
  },
};
</script>

<style>
.maintenanceOperation .testReboot {
  margin-top: 15px;
}

/* SSL证书管理样式 */
.maintenanceOperation .ssl-cert-section {
  margin-top: 30px;
  border-top: 1px solid #e6e6e6;
  padding-top: 20px;
}

.maintenanceOperation .cert-info-box {
  margin-bottom: 20px;
}

.maintenanceOperation .cert-guide-box {
  margin-top: 20px;
}

.maintenanceOperation .cert-upload-box {
  margin-top: 20px;
}

.maintenanceOperation .ssl-notice-box {
  margin-top: 20px;
}

.maintenanceOperation .ssl-notice-box .el-alert__description p {
  margin: 5px 0;
  line-height: 1.6;
}

.maintenanceOperation .ssl-notice-box code {
  background: #f5f5f5;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
}

.maintenanceOperation .info-item {
  margin-bottom: 10px;
}

.maintenanceOperation .info-item label {
  font-weight: bold;
  color: #333;
  margin-right: 8px;
}

.maintenanceOperation .info-item span {
  color: #666;
}

.maintenanceOperation .el-card {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.maintenanceOperation .el-upload__tip {
  color: #999;
  font-size: 12px;
  margin-top: 7px;
}

.maintenanceOperation .el-form-item {
  margin-bottom: 22px;
}

/* SSL证书指导步骤样式 */
.maintenanceOperation .guide-content {
  padding: 10px 0;
}

.maintenanceOperation .guide-content h4 {
  color: #409eff;
  margin: 0 0 10px 0;
  font-size: 14px;
  font-weight: bold;
}

.maintenanceOperation .guide-content h5 {
  color: #e6a23c;
  margin: 15px 0 8px 0;
  font-size: 13px;
  font-weight: bold;
}

.maintenanceOperation .guide-content ul, 
.maintenanceOperation .guide-content ol {
  margin: 10px 0;
  padding-left: 20px;
}

.maintenanceOperation .guide-content li {
  margin: 8px 0;
  line-height: 1.6;
  color: #606266;
}

.maintenanceOperation .tip-box {
  margin: 15px 0;
}

.maintenanceOperation .tip-box .el-alert {
  border-radius: 4px;
}

.maintenanceOperation .tip-box .el-alert p {
  margin: 5px 0;
  line-height: 1.5;
}

.maintenanceOperation .problem-section {
  margin: 20px 0;
  padding: 15px;
  background: #fafafa;
  border-radius: 4px;
  border-left: 3px solid #f56c6c;
}

.maintenanceOperation .problem-section ul {
  margin: 8px 0 0 0;
}

.maintenanceOperation .guide-content code {
  background: #f1f2f3;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Monaco', 'Consolas', 'Courier New', monospace;
  font-size: 12px;
  color: #e6a23c;
}

.maintenanceOperation .el-collapse-item__header {
  font-weight: bold;
  color: #303133;
}

.maintenanceOperation .el-collapse-item__content {
  padding-bottom: 20px;
}
</style>